<template>
    <workflowphase-overview v-bind="$props">
        <template #workflowcard_item_actions="{ data, layout }">
            <el-dropdown placement="bottom-end" size="large" split-button v-for="roleProperty in roleProperties" :disabled="role_disabled(data)">
                {{ resolveProperty(data, roleProperty.id)?.value ?? trans("Selecteer rol") }}
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item v-for="(option, value) in JSON.parse(roleProperty.options_json)" @click.prevent="handleRole(data, roleProperty, value)">
                            {{ option }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </template>
    </workflowphase-overview>
</template>

<script>
import {defineComponent, defineProps, inject, computed, reactive, ref} from "vue";

import Popup from "components/popup";


import Dropdown from "components/dropdown";
import Icon from "components/icon";

import trans from "helpers/_translation";
import { env } from "config";

import { addNotification } from "store/notifications";

import Actions from "components/workflowcard/actions";
import WorkflowcardAdd from "view/dashboard/includes/workflowcard-add";

import workflowphaseList from "view/dashboard/includes/workflowphase-list";
import workflowphaseOverview from "view/dashboard/includes/workflowphase-overview";

import { contact, lower_roles, rolePropertyNames, role_disabled, value, user_avatar } from "store/portal";
import { getWorkflowpropertiesByNames, resolveProperty } from "store/workflow";

import {setWorkflowpropertyfield} from "helpers/_workflowpropertyfield";

export default defineComponent({
    name: "user-overview",
    components: {
        Icon,
        Popup,
        Dropdown,

        Actions,
        WorkflowcardAdd,

        workflowphaseList,
        workflowphaseOverview
    },
    props: {
        workflowboard_id: {
            type: String,
            required: true
        },

        layout: {
            type: String,
            required: false,
            default: null
        },
        simple: {
            type: Boolean,
            required: false,
            default: false
        },
        related_filter_json: {
            type: String,
            required: false,
            default: "{}"
        }
    },
    setup(props) {
        const viewData = inject("viewData");


        const roleProperties = computed(() => {
            return getWorkflowpropertiesByNames(rolePropertyNames.value);
        });
        const roles = (roleProperty) => {
            return computed(() => {
                const result = JSON.parse(roleProperty.options_json);
                // Filter items by key, only keep lower_roles
                return Object.keys(result).filter(key => lower_roles.value.includes(key)).map(key => result[key]);
            }).value;
        };

        const handleRole = (data, property, value) => {
            // Not allowed to change role
            if (role_disabled(data)) return;
            // Set role
            setWorkflowpropertyfield(data, data.id, property, value);
            addNotification(trans("Gebruikersrol is ingesteld."), 3500);
        };

        return {
            env,
            value,

            viewData,

            user_avatar,
            contact,
            trans,

            roleProperties,
            resolveProperty,

            roles,
            role_disabled,

            handleRole
        };
    },
});

</script>